// components/CardBlock.tsx
import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import remarkEmoji from "remark-emoji";
import { rehypeLinkTypes } from "../rehypePlugin/rehypeLinkType";
import { markdownComponents } from "../MarkdownComponent";
import rehypeRaw from "rehype-raw";
 
type TextBlockProps = {
  content: string;
  typingEffect?: boolean;
};

export const TextBlock: React.FC<TextBlockProps> = ({ content, typingEffect = true }:TextBlockProps) => {

  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const endOfTextRef = useRef<HTMLDivElement | null>(null);
  
    useEffect(() => {
      if (!typingEffect) {
        setDisplayedText(content);
        return
      };
  
      if (currentIndex < content.length) { 
        const remainingLength = content.length;
        const typingSpeed = Math.max(0, Math.min(10, Math.floor(1000 / remainingLength))); 
        if(typingSpeed == 0){
          setDisplayedText(content);
          return;
        }
        const timeoutId = setTimeout(() => {
          setDisplayedText((prevText) => prevText + content[currentIndex]);
          setCurrentIndex((prevIndex) => prevIndex + 1);
        }, typingSpeed);
        return () => clearTimeout(timeoutId);
      }
    }, [currentIndex, content]);
  
    useEffect(() => {
      // Llamar al scroll hacia abajo cada vez que el texto se actualiza
      endOfTextRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [displayedText]);

  return (
    
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks, remarkEmoji]}
        rehypePlugins={[rehypeLinkTypes, rehypeRaw]}
        components={markdownComponents}
      >
        {displayedText}
      </ReactMarkdown>
    
  );
};
